import React from 'react'
import { Link, useParams } from 'react-router-dom'
import fetch from 'isomorphic-fetch'
import { useQuery } from 'react-query'

import { guessVars } from '../../actions/states/new/setupVars'
import { getSortedWebinars, guessLatestFromProps } from '../../actions/states/webinars'

const LatestWebinar = () => {
  const params = useParams()
  const selectedState = params.state
  const variableArray = guessVars(selectedState)
  const qsParam = variableArray?.siteId ? `?regionId=${variableArray.siteId}` : ''
  const { data, isLoading } = useQuery(['latest-webinars', qsParam], () => {
    return fetch(`/api/v2/marketing/webinars${qsParam}`, {
      method: 'GET'
    }).then(resp => resp.json())
  })

  if (isLoading) {
    return <div>Loading</div>
  }

  const sortedHistory = getSortedWebinars(data?.history)
  const latest = guessLatestFromProps(sortedHistory, params?.arrayIndex)
  const months = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December'
  }
  const shortishDate = inp => {
    if (!inp) {
      return ''
    }

    const jsDate = new Date(inp)

    return `${months[jsDate.getMonth()]} ${1900 + jsDate.getYear()}`
  }

  return (
    <div>
      <div className="container">
        <div className="row">
          <h2 className="page-title"> {shortishDate(latest.date)} Webinar</h2>
        </div>
      </div>
      <div
        className="title-block-bar"
        style={{ paddingTop: '75px', backgroundColor: '#53ad64' }}>
        <div className="container">
          <h3 style={{ fontSize: '1.6rem', color: 'white', marginBottom: '20px' }}>
            {latest?.title ?? ''}
          </h3>
          <p style={{ fontSize: '1.2rem', marginRight: '20px' }}>
            {latest?.description ?? ''}
          </p>
        </div>
      </div>

      <div className="container" style={{ marginTop: '25px', marginBottom: '25px' }}>
        {latest ? (
          <div>
            <div className="embed-responsive embed-responsive-16by9">
              <video
                width="320"
                height="240"
                controls="true"
                key={latest.videoUrl}
                className="embed-responsive-item">
                <source src={latest.videoUrl} type="video/mp4" />
              </video>
            </div>
          </div>
        ) : (
          <h3 className="text-center">Webinar not Found</h3>
        )}
      </div>

      <div
        className="title-block-bar"
        style={{ paddingTop: '75px', backgroundColor: '#eee' }}>
        <div className="container">
          <h3 style={{ marginBottom: '25px' }}>Previous Webinars</h3>
          <ul>
            {sortedHistory?.map((w, idx) => {
              if (w !== latest) {
                return (
                  <li key={`history-item-${idx}`}>
                    <Link
                      to={`${
                        selectedState ? `/${selectedState}` : ''
                      }/webinar/latest/${idx}`}>
                      {shortishDate(w.date)}: {w.title}
                    </Link>
                  </li>
                )
              }

              return null
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default LatestWebinar
